var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPersonalWebsite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-10"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 83.56,
    y: 82.95,
    width: 111.16,
    height: 194.48,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.19,279.29S106,191.8,99.63,182.18c0,0,36.42-27.34,37.53-101.45H81.9V279.29Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.08,278.91s12.17-87.5,18.55-97.11c0,0-36.41-27.35-37.53-101.45h55.26V278.91Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.64,75.54H73.26V283.86H202.8V75.54ZM105.9,183.77v49.54H83.56V183.77Zm-22.34-3.58V128.92H105.9v51.27Zm56.35,0V128.92h28v51.27Zm28,3.58v49.54h-28V183.77Zm-61-3.58V128.92h29.43v51.27Zm29.43,3.58v49.54H106.9V183.77ZM106.9,128V83h29.43V128ZM136.33,234.2v43.25H106.9V234.2Zm3.58,0h28v43.25h-28Zm0-106.17V83h28V128Zm28.94,55.74h23.64v49.54H168.85Zm0-3.58V128.92h23.64v51.27ZM192.49,128H168.85V83h23.64ZM105.9,83V128H83.56V83ZM83.56,234.2H105.9v43.25H83.56Zm85.29,43.25V234.2h23.64v43.25Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 234.99,
    y: 121.48,
    width: 338.21,
    height: 226.52,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 234.99,
    y: 121.48,
    width: 338.21,
    height: 22.63,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.64,132.79a2.74,2.74,0,1,1-2.73-2.54A2.64,2.64,0,0,1,249.64,132.79Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.46,132.79a2.74,2.74,0,1,1-2.73-2.54A2.64,2.64,0,0,1,258.46,132.79Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.28,132.79a2.74,2.74,0,1,1-2.73-2.54A2.64,2.64,0,0,1,267.28,132.79Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "676.74 166.24 608.79 166.24 608.79 254.85 676.74 256.56 676.74 166.24",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "672.27 169.4 612.81 169.4 612.81 249.76 672.27 251.77 672.27 169.4",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "661.86 184 622.4 182.5 622.4 238.67 661.86 238.67 661.86 184",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "622.4 238.67 661.86 209.81 622.4 182.5 622.4 238.67",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "669.25 103.89 631.43 102.71 631.43 152.03 669.25 152.98 669.25 103.89",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "666.76 106.04 633.67 104.47 633.67 149.19 666.76 150.31 666.76 106.04",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "660.97 112.59 639.01 111.76 639.01 143.02 660.97 143.02 660.97 112.59",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "639.01 143.02 660.97 126.96 639.01 111.76 639.01 143.02",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "409.06 62.12 405.44 95.74 451.85 95.74 455.7 62.12 409.06 62.12",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "410.97 64.33 407.44 93.75 449.33 93.75 452.72 64.33 410.97 64.33",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "418.02 69.48 415.85 89.01 442.28 89.01 443.64 69.48 418.02 69.48",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "469.62 50.71 464.76 95.74 526.94 95.74 532.1 50.71 469.62 50.71",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "472.17 53.67 467.45 93.08 523.57 93.08 528.11 53.67 472.17 53.67",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "481.62 60.57 478.71 86.72 514.12 86.72 515.94 60.57 481.62 60.57",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 374.23,
    y: 95.74,
    width: 181.08,
    height: 5.18,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "405.21 113.52 397.28 100.92 409.06 100.92 409.06 113.52 405.21 113.52",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "401.11 100.92 408.12 113.52 409.06 113.52 409.06 100.92 401.11 100.92",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "509.69 113.52 501.76 100.92 513.54 100.92 513.54 113.52 509.69 113.52",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "505.59 100.92 512.6 113.52 513.54 113.52 513.54 100.92 505.59 100.92",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M157.62,403.69c16.67-10.9,20.9-31.79,20.71-50.65,0-3.15.4-6.46-1.05-9.26s-4.94-4.76-7.83-3.51c-2.39,1.05-3.49,3.74-4.87,6a18.53,18.53,0,0,1-7.65,6.87c-2.05,1-4.58,1.56-6.56.42-2.71-1.56-2.94-5.32-2.85-8.45l.54-17.49a28.56,28.56,0,0,0-.73-9.32c-.91-3-3-5.8-6-6.71s-6.77.72-7.48,3.77a28.07,28.07,0,0,0-.18,3.9c-.12,1.29-.77,2.72-2,3s-2.52-.58-3.45-1.52c-3.19-3.24-5.32-7.36-7.29-11.46S117,301,114.1,297.48s-6.92-6.35-11.46-6.71S93.2,293.06,92,297.43s1.24,8.93,4,12.57a70.47,70.47,0,0,0,14.39,14.21,5.74,5.74,0,0,1,2.4,2.68c.64,2.1-1.41,4.12-3.52,4.76-2.38.72-4.94.42-7.42.64s-5.18,1.24-6.17,3.53c-1.38,3.17,1.25,6.58,3.86,8.84a60.75,60.75,0,0,0,17.7,10.66c2.31.89,4.74,1.69,6.58,3.35s2.91,4.51,1.72,6.68-4.12,2.82-6.56,2.31-4.58-1.86-6.89-2.79c-4.32-1.73-10-1.56-12.83,2.09a9.8,9.8,0,0,0-1.29,8.73,22.9,22.9,0,0,0,4.62,7.85,61,61,0,0,0,25.59,18.68c10,3.7,19.37,4.86,29.5,1.47",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.63,293.25l.3.3.92.86c.82.74,2,1.84,3.52,3.29a117.61,117.61,0,0,1,11.79,13.19c2.29,3,4.66,6.3,7.14,9.94s5.1,7.54,7.69,11.75a142.08,142.08,0,0,1,7.5,13.56c1.16,2.42,2.19,4.95,3.24,7.53l3.17,7.84a283.4,283.4,0,0,1,10.56,30.39,138,138,0,0,1,4.66,25.8,100.87,100.87,0,0,1-.14,17.69c-.21,2.08-.41,3.69-.59,4.78-.07.52-.13.93-.18,1.24a3.35,3.35,0,0,0,0,.42,1.47,1.47,0,0,0,.1-.41l.24-1.23c.21-1.09.45-2.7.7-4.78a96.37,96.37,0,0,0,.32-17.74A135.61,135.61,0,0,0,153,391.76a276.75,276.75,0,0,0-10.54-30.46l-3.17-7.85c-1.05-2.57-2.09-5.12-3.27-7.55a137.33,137.33,0,0,0-7.55-13.6c-2.62-4.21-5.25-8.11-7.75-11.75s-4.89-7-7.21-9.91a110.37,110.37,0,0,0-12-13.1c-1.53-1.43-2.75-2.51-3.59-3.22l-1-.81A2,2,0,0,0,96.63,293.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.84,345.87a6.08,6.08,0,0,0,.34-1.33c.19-.86.42-2.11.68-3.66.52-3.11,1.1-7.42,1.72-12.18s1.25-9.05,1.82-12.14c.28-1.55.52-2.79.7-3.66a6.26,6.26,0,0,0,.21-1.35,6,6,0,0,0-.43,1.3c-.24.85-.55,2.09-.88,3.63-.68,3.08-1.38,7.38-2,12.14s-1.14,8.95-1.55,12.19c-.2,1.47-.36,2.7-.49,3.69A5.84,5.84,0,0,0,135.84,345.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.25,337.38a9,9,0,0,0,1.62.23c1,.12,2.56.28,4.42.53,3.72.49,8.85,1.34,14.45,2.52s10.64,2.49,14.25,3.53c1.81.5,3.26.95,4.27,1.26a8,8,0,0,0,1.58.42,9.47,9.47,0,0,0-1.51-.64c-1-.37-2.42-.88-4.22-1.44-3.59-1.14-8.62-2.5-14.25-3.7s-10.77-2-14.52-2.36c-1.87-.2-3.4-.3-4.45-.35A8.7,8.7,0,0,0,95.25,337.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.5,391a1.89,1.89,0,0,0,.29-.49l.73-1.44c.64-1.25,1.5-3.08,2.54-5.37,2.08-4.56,4.75-10.95,7.6-18s5.46-13.5,7.45-18.1c1-2.24,1.76-4.08,2.36-5.44l.63-1.49a2.73,2.73,0,0,0,.19-.53,2.1,2.1,0,0,0-.3.48c-.19.39-.44.87-.73,1.44-.63,1.25-1.49,3.09-2.53,5.37-2.08,4.56-4.75,11-7.61,18.05s-5.46,13.5-7.44,18.1L153.32,389l-.63,1.48A2,2,0,0,0,152.5,391Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.75,372.48a2,2,0,0,0,.53.23l1.56.56,5.76,2c4.86,1.69,11.54,4.09,18.92,6.76s14.1,5,19,6.59c2.45.8,4.44,1.42,5.82,1.82l1.59.46a2.6,2.6,0,0,0,.57.12,2.21,2.21,0,0,0-.53-.24l-1.56-.55-5.76-2c-4.86-1.68-11.54-4.08-18.93-6.75s-14.09-5-19-6.6c-2.45-.79-4.44-1.41-5.82-1.82l-1.59-.45A2.08,2.08,0,0,0,98.75,372.48Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M611.59,441.57c0,.15-112.14.26-250.45.26s-250.47-.11-250.47-.26,112.12-.26,250.47-.26S611.59,441.43,611.59,441.57Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M519.22,140.74H178.79a10.62,10.62,0,0,0-10.62,10.63V391.82a10.62,10.62,0,0,0,10.62,10.63H309.45s8.31,25.7-17.46,39H414.16s-29.08-10-21.6-39H519.22a10.63,10.63,0,0,0,10.63-10.63V151.37A10.63,10.63,0,0,0,519.22,140.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.91,377.07c4.63,6.62-2.62,13.87-9.24,9.24a2.37,2.37,0,0,1-.57-.57c-4.62-6.62,2.62-13.86,9.24-9.24A2.37,2.37,0,0,1,353.91,377.07Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176.2,
    y: 152.89,
    width: 345.61,
    height: 205,
    rx: 3.27,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176.2,
    y: 167.91,
    width: 345.61,
    height: 189.98,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.55,160.8a2.76,2.76,0,1,1-2.76-2.76A2.76,2.76,0,0,1,204.55,160.8Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.82,160.8a2.76,2.76,0,1,1-2.76-2.76A2.76,2.76,0,0,1,187.82,160.8Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.85,160.8a2.76,2.76,0,1,1-2.76-2.76A2.76,2.76,0,0,1,195.85,160.8Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.49,256.37c0,.15-12.66.28-28.27.28s-28.28-.13-28.28-.28,12.66-.28,28.28-.28S346.49,256.21,346.49,256.37Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.49,263.94c0,.15-12.66.28-28.27.28s-28.28-.13-28.28-.28,12.66-.29,28.28-.29S346.49,263.78,346.49,263.94Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.83,271.5c0,.16-7.58.29-16.94.29s-16.95-.13-16.95-.29,7.59-.28,16.95-.28S323.83,271.35,323.83,271.5Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289.94,
    y: 179.03,
    width: 26.89,
    height: 3.41,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289.94,
    y: 190.02,
    width: 59.09,
    height: 57.17,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "294.52 242.29 310.87 212.87 324.24 231.68 332.36 221.69 344.45 242.29 294.52 242.29",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 325.68,
    cy: 207.15,
    r: 4.25,
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.45,242.45a.82.82,0,0,1,0-.23c0-.18,0-.39,0-.67,0-.61,0-1.47,0-2.57,0-2.27,0-5.55-.06-9.71,0-8.35-.07-20.24-.12-34.52l.24.24-49.92,0c-.07.06.52-.53.27-.27h0v12.82c0,4.2,0,8.32,0,12.32,0,8,0,15.58,0,22.54l-.25-.25,36.1.13,10.18.06,2.7,0,.7,0h0l-.67,0-2.66,0-10.12.06-36.26.13h-.24v-.25c0-7,0-14.53,0-22.54,0-4,0-8.12,0-12.32V194.77h0c-.25.24.34-.36.29-.29l49.92,0h.24v.24c-.05,14.34-.09,26.28-.12,34.67,0,4.14-.05,7.4-.07,9.66,0,1.08,0,1.92,0,2.52,0,.27,0,.48,0,.64A1.66,1.66,0,0,1,344.45,242.45Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.53,256.37c0,.15-12.66.28-28.28.28s-28.27-.13-28.27-.28,12.65-.28,28.27-.28S418.53,256.21,418.53,256.37Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.53,263.94c0,.15-12.66.28-28.28.28s-28.27-.13-28.27-.28,12.65-.29,28.27-.29S418.53,263.78,418.53,263.94Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.87,271.5c0,.16-7.59.29-16.95.29S362,271.66,362,271.5s7.58-.28,16.94-.28S395.87,271.35,395.87,271.5Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 361.98,
    y: 179.03,
    width: 26.89,
    height: 3.41,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 361.98,
    y: 190.02,
    width: 59.09,
    height: 57.17,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "366.56 242.29 382.9 212.87 396.27 231.68 404.4 221.69 416.48 242.29 366.56 242.29",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402,207.15a4.26,4.26,0,1,1-4.25-4.25A4.25,4.25,0,0,1,402,207.15Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.48,242.45s0-.08,0-.23,0-.39,0-.67c0-.61,0-1.47,0-2.57,0-2.27,0-5.55-.06-9.71,0-8.35-.08-20.24-.13-34.52l.24.24-49.92,0c-.07.06.53-.53.28-.27h0v12.82c0,4.2,0,8.32,0,12.32,0,8,0,15.58,0,22.54l-.24-.25,36.1.13,10.18.06,2.7,0,.7,0h0l-.68,0-2.65,0-10.13.06-36.25.13h-.25v-.25c0-7,0-14.53,0-22.54V194.77h0c-.26.24.34-.36.28-.29l49.92,0h.25v.24c-.06,14.34-.1,26.28-.13,34.67,0,4.14-.05,7.4-.06,9.66q0,1.62,0,2.52c0,.27,0,.48,0,.64A.85.85,0,0,1,416.48,242.45Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 291.83,
    y: 282.05,
    width: 26.89,
    height: 3.41,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 291.83,
    y: 293.03,
    width: 59.09,
    height: 57.17,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "296.41 345.31 312.76 315.89 326.13 334.69 334.25 324.71 346.34 345.31 296.41 345.31",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.83,310.17a4.26,4.26,0,1,1-4.26-4.26A4.25,4.25,0,0,1,331.83,310.17Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.34,345.47s0-.09,0-.24,0-.39,0-.67c0-.6,0-1.46,0-2.57,0-2.26,0-5.54-.07-9.71,0-8.35-.07-20.24-.12-34.51l.24.24-49.92,0,.28-.28V301c0,1.08,0,2.16,0,3.23v18.69c0,8,0,15.57,0,22.54l-.25-.25,36.1.13,10.18.06,2.71,0h.7a1.22,1.22,0,0,1,.24,0h-.89l-2.65,0-10.13.07-36.26.12h-.24v-.24c0-7,0-14.54,0-22.54q0-6,0-12.32V297.77l.29-.29,49.92,0h.24v.25c-.05,14.34-.09,26.28-.12,34.67,0,4.14,0,7.4-.06,9.65,0,1.09,0,1.93,0,2.53,0,.26,0,.47,0,.64A.67.67,0,0,1,346.34,345.47Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 363.92,
    y: 282.05,
    width: 26.89,
    height: 3.41,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 363.92,
    y: 293.03,
    width: 59.09,
    height: 57.17,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "368.5 345.31 384.85 315.89 398.22 334.69 406.34 324.71 418.43 345.31 368.5 345.31",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.91,310.17a4.25,4.25,0,1,1-4.25-4.26A4.25,4.25,0,0,1,403.91,310.17Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.43,345.47a1.35,1.35,0,0,1,0-.24c0-.17,0-.39,0-.67,0-.6,0-1.46,0-2.57,0-2.26,0-5.54-.06-9.71,0-8.35-.07-20.24-.12-34.51l.24.24-49.93,0,.28-.28v12.84q0,6.3,0,12.32c0,8,0,15.57,0,22.54l-.25-.25,36.1.13,10.18.06,2.7,0h.7l.25,0h-.89l-2.66,0-10.12.07-36.26.12h-.25v-.24c0-7,0-14.54,0-22.54q0-6,0-12.32V297.77l.28-.29,49.93,0h.24v.25c-.05,14.34-.09,26.28-.12,34.67,0,4.14-.05,7.4-.07,9.65,0,1.09,0,1.93,0,2.53,0,.26,0,.47,0,.64A1.66,1.66,0,0,1,418.43,345.47Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 438.3,
    y: 282.05,
    width: 26.89,
    height: 3.41,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 438.3,
    y: 293.03,
    width: 59.09,
    height: 57.17,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "442.88 345.31 459.23 315.89 472.6 334.69 480.72 324.71 492.81 345.31 442.88 345.31",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.3,310.17a4.26,4.26,0,1,1-4.26-4.26A4.25,4.25,0,0,1,478.3,310.17Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.81,345.47s0-.09,0-.24,0-.39,0-.67c0-.6,0-1.46,0-2.57,0-2.26,0-5.54-.07-9.71,0-8.35-.07-20.24-.12-34.51l.24.24-49.92,0,.28-.28v25.16c0,8,0,15.57,0,22.54l-.25-.25,36.1.13,10.18.06,2.71,0h.69a1.27,1.27,0,0,1,.25,0h-.89l-2.65,0-10.13.07-36.26.12h-.24v-.24c0-7,0-14.54,0-22.54q0-6,0-12.32V297.77l.29-.29,49.92,0h.24v.25c-.05,14.34-.09,26.28-.12,34.67,0,4.14-.05,7.4-.06,9.65,0,1.09,0,1.93,0,2.53,0,.26,0,.47,0,.64A.67.67,0,0,1,492.81,345.47Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.86,247.18a38.3,38.3,0,0,1,6.48-.28l-.28.28h0v-.64c0-.22,0-.43,0-.64,0-.42,0-.82,0-1.22,0-.71,0-1.4.06-2.06a6.3,6.3,0,0,1,.2-1.9,7,7,0,0,1,.19,1.9c0,.66,0,1.35.06,2.06,0,.4,0,.8,0,1.22v1.28h0l-.29.29A36.46,36.46,0,0,1,491.86,247.18Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.39,247.18a97.13,97.13,0,0,1,14.74,0,93.79,93.79,0,0,1-14.74,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.17,240.7a37.09,37.09,0,0,1,.28,6.48l-.28-.28h2.53l2.06.06a7.31,7.31,0,0,1,1.9.2,6.37,6.37,0,0,1-1.9.2l-2.06.06-1.22,0h-1.31l-.28-.29A38.3,38.3,0,0,1,441.17,240.7Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.17,211.23a47.92,47.92,0,0,1,.28,7.37,47.73,47.73,0,0,1-.28,7.36,49.29,49.29,0,0,1-.28-7.36A49.48,49.48,0,0,1,441.17,211.23Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.66,190a37.25,37.25,0,0,1-6.49.28l.28-.28h0v1.29c0,.41,0,.82,0,1.22,0,.71,0,1.39-.06,2.06a6.37,6.37,0,0,1-.2,1.9,6.37,6.37,0,0,1-.2-1.9c0-.67,0-1.35-.06-2.06,0-.4,0-.81,0-1.22,0-.21,0-.43,0-.65V190h0l.28-.28A38.47,38.47,0,0,1,447.66,190Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.13,190a97.13,97.13,0,0,1-14.74,0,97.13,97.13,0,0,1,14.74,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.35,196.5a36.62,36.62,0,0,1-.29-6.49c.57.56.16.16.28.28H497l-1.22,0-2.06-.06a6.37,6.37,0,0,1-1.9-.2,6.37,6.37,0,0,1,1.9-.2l2.06-.06h2.52l.29.28A38.47,38.47,0,0,1,498.35,196.5Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.35,226a46.92,46.92,0,0,1-.29-7.36,47.11,47.11,0,0,1,.29-7.37,49.48,49.48,0,0,1,.28,7.37A49.29,49.29,0,0,1,498.35,226Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.52,256.29c0,.15-12.67.28-28.28.28s-28.28-.13-28.28-.28,12.66-.28,28.28-.28S497.52,256.13,497.52,256.29Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.52,263.86c0,.15-12.67.28-28.28.28S441,264,441,263.86s12.66-.29,28.28-.29S497.52,263.7,497.52,263.86Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 440.96,
    y: 178.95,
    width: 26.89,
    height: 3.41,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.45,223.44a29,29,0,1,1-29-29A29,29,0,0,1,262.45,223.44Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.18,286.6c0,.15-14.88.28-33.23.28s-33.24-.13-33.24-.28,14.88-.29,33.24-.29S268.18,286.44,268.18,286.6Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.18,294c0,.16-14.88.28-33.23.28s-33.24-.12-33.24-.28,14.88-.28,33.24-.28S268.18,293.79,268.18,294Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.18,301.3c0,.16-14.88.28-33.23.28s-33.24-.12-33.24-.28S216.59,301,235,301,268.18,301.15,268.18,301.3Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.9,308.81c0,.16-8.63.28-19.27.28s-19.28-.12-19.28-.28,8.63-.28,19.28-.28S239.9,308.66,239.9,308.81Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 201.71,
    y: 271.6,
    width: 45.8,
    height: 3.35,
    transform: "translate(449.22 546.54) rotate(180)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.31,245.57a28.08,28.08,0,0,0,36.76,0c-1.54-5.24-5.28-11.46-14.37-12.84a11.38,11.38,0,0,0,6.79-10.53c0-6.3-4.74-11.42-10.64-11.45s-10.7,5.06-10.73,11.35a11.39,11.39,0,0,0,6.81,10.64C220.69,234.11,216.88,240.36,215.31,245.57Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 201.71,
    y: 320.29,
    width: 25.68,
    height: 3.13,
    style: {
      fill: "#FF725E"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M586.14,211.66l4.38,14.69a6.89,6.89,0,0,1,.39,2.05c0,2.07-2,3.7-4,4.08a13.78,13.78,0,0,1-6.11-.72c-.54,2.11-3,3-5.15,3.4a47.08,47.08,0,0,1-28.32-3.53,77.26,77.26,0,0,0,9.13-17.46l22.34,1a10.31,10.31,0,0,0,3.92-.33,3.49,3.49,0,0,0,2.44-2.83",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.54,240.35c.28-1.64-.39-8.54-.39-8.54s-6.29-.67-6.67-6.91,0-20.64,0-20.64l11.46-5.6,12.62,9.55-1.91,31.21L562,251.6Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.73,214.75a.8.8,0,1,0,.8-.79A.79.79,0,0,0,554.73,214.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554,213.88c.11.11.7-.39,1.56-.44s1.5.37,1.59.25-.06-.24-.34-.43a2.09,2.09,0,0,0-1.29-.34,2.05,2.05,0,0,0-1.23.49C554,213.64,553.9,213.84,554,213.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564,214.75a.8.8,0,1,0,.79-.79A.79.79,0,0,0,564,214.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.49,213.88c.1.11.69-.39,1.55-.44s1.51.37,1.6.25-.06-.24-.35-.43a2.11,2.11,0,0,0-2.51.15C563.52,213.64,563.44,213.84,563.49,213.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.23,222a15.92,15.92,0,0,1-4.16,1.44,2.43,2.43,0,0,0,2.85.81A1.79,1.79,0,0,0,563.23,222Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.15,231.81a15.57,15.57,0,0,0,8.27-2.79s-1.87,4.58-8.13,4.32Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.72,226.16a4.51,4.51,0,0,1-2.26-.51,6.39,6.39,0,0,1-2.47-2.4,24.61,24.61,0,0,1-1.84-3.95c-1.17-2.9-2-5.6-2.65-7.56-.09-.31-.18-.59-.26-.86a8,8,0,0,0-.16-.86c-3.41-13-14.85-15.44-17.11-15.44-2.43,0-6.68-1.34-12.87,5.1a13.78,13.78,0,0,0-2.35,3.24A14,14,0,0,0,551,208.8a7.16,7.16,0,0,0-.14,3.09c.12,0,.14-1.17.62-3a15.18,15.18,0,0,1,1.2-3.07,11.91,11.91,0,0,0,.63,7.19l2.22-.62,8-2.7c-.73-2.46.34-5.52.94-7l.06,0c1.82,9.34,12.11,10.32,12.11,10.32l-.51,17.73c10.57-2.26,10.71-13.8,10.64-16.67.48,1.62,1.1,3.48,1.88,5.43a24.2,24.2,0,0,0,1.94,4,6.39,6.39,0,0,0,2.74,2.48,4.24,4.24,0,0,0,2.46.36,1.76,1.76,0,0,0,.86-.32A7.23,7.23,0,0,0,595.72,226.16Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.39,221.15A5.93,5.93,0,0,0,559,221c-.22,0-.44,0-.48-.2a1.21,1.21,0,0,1,.12-.7c.19-.56.38-1.15.59-1.78.41-1.27.76-2.42,1-3.26a5.21,5.21,0,0,0,.31-1.38A5.7,5.7,0,0,0,560,215c-.3.82-.69,2-1.1,3.24l-.57,1.79a1.42,1.42,0,0,0-.08.9.57.57,0,0,0,.37.31,1.67,1.67,0,0,0,.37,0A5.84,5.84,0,0,0,560.39,221.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.9,216.07c-1.94-.38-3.58-.65-4.14-.69a4.91,4.91,0,0,0,.12-1,5.13,5.13,0,0,0-1-3,4.92,4.92,0,0,0-2.36-1.75,5.05,5.05,0,0,0-2.65-.2,4.79,4.79,0,0,0-2.1,1,4.87,4.87,0,0,0-1.77,2.77,4,4,0,0,0-.11.9,1,1,0,0,0,0,.31s0-.43.22-1.17a4.89,4.89,0,0,1,1.79-2.62,4.66,4.66,0,0,1,2-.87,4.74,4.74,0,0,1,4.68,7.45,4.67,4.67,0,0,1-2.2,1.66,4.74,4.74,0,0,1-2.48.22,4.67,4.67,0,0,1-2-.88,4.84,4.84,0,0,1-1.79-2.61,5.29,5.29,0,0,1-.17-.9c.15,0,.25-.08.25-.12s-.12-.1-.29-.13v0a3.37,3.37,0,0,0-.6,0,3.12,3.12,0,0,0-.72.08v-.06a5.06,5.06,0,0,0-1-3,4.94,4.94,0,0,0-2.35-1.75,5.09,5.09,0,0,0-2.66-.2,5,5,0,0,0-3.87,3.73,4,4,0,0,0-.11.9,1,1,0,0,0,0,.31s0-.43.22-1.17a4.89,4.89,0,0,1,1.79-2.62,4.66,4.66,0,0,1,2-.87,4.74,4.74,0,0,1,5.59,4.66,4.75,4.75,0,0,1-3.1,4.45,4.78,4.78,0,0,1-2.49.22,4.67,4.67,0,0,1-2-.88,4.84,4.84,0,0,1-1.79-2.61c-.2-.74-.18-1.18-.22-1.18a1.14,1.14,0,0,0,0,.32,3.9,3.9,0,0,0,.11.89,4.88,4.88,0,0,0,1.77,2.78,5,5,0,0,0,2.1,1,5.09,5.09,0,0,0,2.66-.2,5,5,0,0,0,2.35-1.75,5.08,5.08,0,0,0,1-2.75,2.76,2.76,0,0,0,.74.08,4.52,4.52,0,0,0,.58,0v0a3.9,3.9,0,0,0,.11.89,4.95,4.95,0,0,0,3.87,3.74,5.05,5.05,0,0,0,2.65-.2,5,5,0,0,0,2.36-1.75,4.85,4.85,0,0,0,.84-1.88c.53.17,2.15.55,4.11.93a29.76,29.76,0,0,0,4.36.69A26.54,26.54,0,0,0,574.9,216.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.22,220.89a7.61,7.61,0,0,1,.34-3.08,2.91,2.91,0,0,1,2.24-1.94,2.46,2.46,0,0,1,2.54,2,3,3,0,0,1-1.55,3,4,4,0,0,1-3.47.1",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580,220c0-.07.34.08.78,0a1.39,1.39,0,0,0,.93-1.33,1,1,0,0,0-.22-.83.93.93,0,0,0-.68-.2c-.47,0-.8.16-.82.08s.21-.29.77-.44a1.19,1.19,0,0,1,1,.2,1.42,1.42,0,0,1,.43,1.23,1.86,1.86,0,0,1-.46,1.16,1.45,1.45,0,0,1-.92.49C580.27,220.35,580,220,580,220Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.22,457.63l-7.53-5.11,9.49-14.16,11.09,7.36-.53.91c-2.4,4.06-12.49,20.44-15,22.53C598.88,471.48,604.22,457.63,604.22,457.63Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.8,469c-.14-.09,3.33-5.44,7.75-11.94s8.1-11.71,8.24-11.62-3.34,5.44-7.76,12S600.93,469.11,600.8,469Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.59,458.92c0,.16-.47.25-1,.29s-1,0-1.05-.16.41-.39,1-.42S605.61,458.76,605.59,458.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.48,460.16c0,.16-.55.18-1.16.14s-1.12-.12-1.13-.29.51-.33,1.16-.29S605.51,460,605.48,460.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.85,449.68c-.07,0-.26-.27-.49-.78a6,6,0,0,1-.53-2.17,3.45,3.45,0,0,1,.64-2.18c.37-.48.73-.61.77-.55s-.19.31-.43.77a4.06,4.06,0,0,0-.4,1.94,11,11,0,0,0,.34,2.06C613.88,449.3,613.93,449.65,613.85,449.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.15,458c-.07-.14.2-.42.57-.69s.71-.45.83-.34-.07.5-.49.81S604.21,458.15,604.15,458Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603.57,457.29c-.13-.1,0-.55.34-1s.69-.75.82-.67,0,.53-.34,1S603.69,457.39,603.57,457.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.47,469.27v-9.1l17-.11.14,13.32-1.06.07c-4.7.29-23.92,1.15-27.08.22C501,472.63,515.47,469.27,515.47,469.27Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.12,472.83c0-.16,6.38-.29,14.24-.29s14.24.13,14.24.29-6.37.3-14.24.3S504.12,473,504.12,472.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.17,471.13c-.14.08-.47-.25-.81-.69s-.57-.84-.46-1,.56.13.92.61S515.31,471.05,515.17,471.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.08,471.73c-.15.06-.45-.35-.76-.88s-.53-1-.4-1.1.56.24.9.81S514.23,471.67,514.08,471.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.46,472.77c-.06,0,.08-.37.37-.84a6.21,6.21,0,0,1,1.49-1.66,3.55,3.55,0,0,1,2.17-.7c.6,0,.92.27.89.33s-.37,0-.88.08a4.19,4.19,0,0,0-1.83.76,10.64,10.64,0,0,0-1.51,1.44C527.79,472.58,527.53,472.82,527.46,472.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.12,469.42c.08-.14.47-.07.89.08s.78.34.75.5-.45.22-.94.05S515,469.56,515.12,469.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.39,468.54c0-.16.47-.29,1-.28s1,.15,1,.31-.44.28-1,.28S515.37,468.7,515.39,468.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.47,259.15,540,253s-8.15,23.48-10.65,23.71c-13.84,1.26-28.65-3.33-33.85-5.14-.52-.59-1.12-1.3-1.79-2.17a8.26,8.26,0,0,1-1.31-2.49,13,13,0,0,1-.74-3.42,1.09,1.09,0,0,0-1.87-.86c-.59.78-.75,3.74.62,6.94s-3.47.65-5.25-.25-7.41-3.4-8.12-3.07c-1,.49-.71,1.69,1.09,2.54s7,3.78,6.49,4.7-9.51-3.77-9.51-3.77-1.76-1.31-2.39-.27c-1.14,1.87,8.78,6.14,9.74,6.52.66.26.14,1.28-.56,1s-8.86-4.87-10.05-3c-.9,1.45,8.14,3.58,9.31,5.46s-6.7-2.31-7.5-.88c-.3.53-.46,1,4.4,2.72A102.51,102.51,0,0,0,488.92,284l0,.05s48.55,21.71,59,.79C559,262.64,558.47,259.15,558.47,259.15Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547.17,310.75s-11.77,78.22-10.08,82,62.22,68,62.22,68l14.16-24.26s-47.75-53.3-47.39-54.73S583,304.26,583,304.26Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "549.74 407.36 559.69 385.51 569.64 363.66 552.88 392.71 549.74 407.36",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.67,387.87a4.87,4.87,0,0,1,.06.86c0,.62,0,1.45.06,2.48l0-.08c3.79,4.28,12.19,14,21.89,25.36l16.85,19.86,5.06,6.07c.56.68,1,1.24,1.35,1.66a3.13,3.13,0,0,1,.44.61,4,4,0,0,1-.53-.53l-1.43-1.6c-1.28-1.45-3-3.47-5.2-5.94l-17-19.75c-9.69-11.35-18-21.17-21.63-25.58l0,0v0c0-1,0-1.86.05-2.48A3.45,3.45,0,0,1,555.67,387.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.93,431.47c.14.09-3.17,5.34-7.38,11.72s-7.73,11.49-7.86,11.4,3.17-5.34,7.38-11.72S608.8,431.38,608.93,431.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.91,340.13c.11-.82,9.51-22,9.51-22l-4.56-6.43-.81-.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.39,310l-9.34,1.56,5.37,6.61c-8.67,19.62-26.58,61.16-28.73,74.55-2.86,17.74-13.63,73.15-12.55,74s25.91,0,25.91,0l15.83-74,35-60.62a33.82,33.82,0,0,0,3.55-24.95l-.7-2.88",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.41,458.5a2.53,2.53,0,0,1,.05-.41c0-.3.1-.7.18-1.21l.77-4.63c.71-4.05,1.72-9.86,3-17s2.81-15.73,4.5-25.21c.88-4.74,1.8-9.72,2.75-14.88.24-1.28.5-2.58.75-3.89.13-.66.25-1.31.4-2,.08-.33.14-.67.24-1l.37-1c1-2.54,2.14-5,3.26-7.59,9.05-20.33,17.47-38.63,23.56-51.87l7.27-15.67c.85-1.82,1.53-3.24,2-4.24.22-.46.4-.83.54-1.1a2,2,0,0,1,.2-.37l-.15.4-.48,1.12-1.91,4.29C574,316,571.56,321.4,568.58,328c-6,13.29-14.36,31.61-23.4,51.94-1.12,2.54-2.25,5.06-3.25,7.55l-.36.92c-.1.32-.15.65-.23,1-.15.64-.27,1.31-.41,2-.25,1.31-.5,2.61-.75,3.89-1,5.15-1.89,10.13-2.78,14.86-1.74,9.48-3.31,18-4.63,25.19s-2.39,12.94-3.13,17c-.38,2-.68,3.52-.88,4.61-.11.5-.19.9-.25,1.2A1.61,1.61,0,0,1,528.41,458.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.53,459.6c0,.16-6,.18-13.31,0s-13.31-.37-13.31-.53,6-.18,13.32-.05S538.54,459.44,538.53,459.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "547.05 311.55 547.41 312.4 592.28 308.77 590.7 304.26 547.05 311.55",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.58,238.45l-3,12.12-.11-8.72.23-1.93.27-1.47-4-1.35-2.06,3.21-.6,0s-16.15-1.61-21.8,19.73l-5.17,12.65,15.65,7.8,0,1,1,30.19,45.2-7.32c.18-6.78-6.74-19.06-5.21-25.2l5.21-21-6.83-19.57-4.73.15h0L577,235.63l-11.37,2.82",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.27,280.31a2.83,2.83,0,0,1-1-.51,7.57,7.57,0,0,1-2.09-2.16,6.82,6.82,0,0,1-1.07-4.31,9.61,9.61,0,0,1,1.76-5.16,9.41,9.41,0,0,1,3.2-2.86l-.14.18c.38-2.77.72-5.15,1-6.84a17.12,17.12,0,0,1,.5-2.67,18.39,18.39,0,0,1-.2,2.72c-.17,1.69-.44,4.09-.78,6.86l0,.12-.12.07a9.33,9.33,0,0,0-4.7,7.61,6.61,6.61,0,0,0,.9,4.09,8.29,8.29,0,0,0,1.9,2.18C545,280.07,545.28,280.27,545.27,280.31Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547,260c-.13.06-.57-.58-1-1.44s-.66-1.61-.53-1.67.57.58,1,1.44S547.1,259.88,547,260Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.76,251.42l142.18,27.31c10.14,1.95,16.52,11.21,15.37,21.76a3.11,3.11,0,0,1-.08.44,19.15,19.15,0,0,1-22.66,15.19L496.23,288,465.5,263.44Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.76,251.42s7.76,2.91,6.16,10.35-9.11,7.13-9.11,7.13,7.3,1.62,5.28,12.05c-1.31,6.72-6.86,7.07-6.86,7.07L465.5,263.44Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.18,268.78c3-1.49,4.05-5.46,3-8.63l-9.65,3.29Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641,297.92l-.37-.05-1.1-.18-4.19-.75c-3.64-.66-8.89-1.65-15.39-2.9-13-2.5-30.89-6.09-50.65-10.17l-50.58-10.52-15.33-3.21-4.16-.89-1.08-.25a1.59,1.59,0,0,1-.37-.1,2.07,2.07,0,0,1,.38.05l1.09.19,4.18.8L518.82,273l50.62,10.37c19.75,4.08,37.65,7.73,50.62,10.32l15.35,3.06,4.17.85,1.09.23A1.39,1.39,0,0,1,641,297.92Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635.57,316.12a19.15,19.15,0,0,0,22.66-15.19,3.11,3.11,0,0,0,.08-.44c1.15-10.55-5.23-19.81-15.37-21.76Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.06,257.11S570.41,284.4,568,285c-13.48,3.44-28.83,1.25-34.24.28-.61-.5-1.33-1.12-2.12-1.86a8.43,8.43,0,0,1-1.68-2.25,12.6,12.6,0,0,1-1.27-3.26,1.09,1.09,0,0,0-2-.55c-.47.86-.15,3.81,1.7,6.75,0,0-10.84,6.88-13.21,6.82s-9.16-.23-8.45.71,8.45,2.23,8.45,2.23l14,4.75s51.36,13.82,58.39-8.5c4.3-13.68,7.28-21.73,7.95-25Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.43,238.63s11.3,2,11.74,20.5a72.16,72.16,0,0,1-7.08,32.54l-19.88-10.44a122.81,122.81,0,0,0,10-28.13l5.16-14.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.63,254.13a5,5,0,0,1-.13,1.14c-.11.72-.3,1.76-.58,3a88.69,88.69,0,0,1-2.77,9.83,87.16,87.16,0,0,1-3.91,9.44c-.57,1.18-1.06,2.12-1.42,2.75a5.48,5.48,0,0,1-.6,1,4.21,4.21,0,0,1,.42-1.06c.34-.77.77-1.71,1.27-2.81,1.06-2.38,2.44-5.71,3.75-9.46s2.26-7.22,2.9-9.75q.44-1.77.75-3A4.66,4.66,0,0,1,578.63,254.13Z",
    style: {
      fill: "#455a64"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonalWebsite);
export default __webpack_public_path__ + "static/media/personalWebsite.2f5a51d3192fd2775d78c31028654e8b.svg";
export { ForwardRef as ReactComponent };